import { ConvergenceInfo } from '../../../types/pivotPoints.ts';

/**
 * Calculate convergence ratio and level from pivot data
 * Formula: (R1 - S1) / PP
 */
export function calculateConvergence(r1: number, s1: number, pp: number): ConvergenceInfo {
  if (!r1 || !s1 || !pp || pp === 0) {
    return { ratio: 0, level: 'none' };
  }

  const ratio = Math.abs((r1 - s1) / pp);

  let level: ConvergenceInfo['level'] = 'none';
  if (ratio < 0.01) {
    level = 'tight'; // Very tight range, high probability of breakout
  } else if (ratio < 0.02) {
    level = 'convergence'; // Moderate convergence
  }

  return { ratio, level };
}

/**
 * Get convergence badge display text
 */
export function getConvergenceBadgeText(level: ConvergenceInfo['level']): string | null {
  switch (level) {
    case 'tight':
      return 'Tight Range';
    case 'convergence':
      return 'Convergence';
    case 'none':
    default:
      return null;
  }
}

/**
 * Get convergence badge color class
 */
export function getConvergenceBadgeColor(level: ConvergenceInfo['level']): string {
  switch (level) {
    case 'tight':
      return 'convergence-tight'; // Orange/alert
    case 'convergence':
      return 'convergence-moderate'; // Yellow/warning
    case 'none':
    default:
      return '';
  }
}
